import { jsx as _jsx } from "react/jsx-runtime";
import announcekitStore from "../../../client-store/announcekit.store.js";
// import components
import AnnounceKit from "announcekit-react";
export const AnnounceKitAtomComponent = (props) => (_jsx(AnnounceKit, { ...props, widgetStyle: { display: "none" }, ref: (ref) => {
        if (ref)
            announcekitStore.setRef(ref);
    }, onWidgetClose: () => {
        announcekitStore.updateUnreads();
    } }));
export default AnnounceKitAtomComponent;
